<template>
  <a-modal
    :title="title"
    v-model="modalShow"
    width="80%"
    @cancel="close"
    destroyOnClose
  >
    <div class="common-title">即将提交以下祺信的付款凭证</div>
    <div class="table-common common">
      <a-table
        size="middle"
        :columns="columns"
        :row-key="record => record.id"
        :data-source="tableData"
        :pagination="false"
        bordered
        :locale="{ emptyText: '暂无数据' }"
      >
        <template slot="exDate" slot-scope="text">
          {{ text | dateFormat("YYYY-mm-dd") }}
        </template>
        <template slot="payAmount" slot-scope="text, record">
          {{ record.payAmount | splitK }}
        </template>
        <template slot="operation" slot-scope="text, record">
          <a
            @click="uploadVoucher(record, 'detail')"
          >
            查看凭证
          </a>
        </template>
      </a-table>
    </div>
    <uploadVoucherDialog ref="uploadVoucherDialog"/>
    <template slot="footer">
      <a-button class="btn-blue-line" @click="close()">取消</a-button>
      <button-load @clickHandle="openPasswordDialog" type="primary" lable="提交" />
    </template>
    <commonPasswordModal ref="commonPasswordModal" @success="passwordSuccess"/>
  </a-modal>
</template>

<script>
import uploadVoucherDialog from "@/pages/bill-payment/uploadVoucherDialog.vue"
import commonPasswordModal from "@/pages/bill-payment/common-password-modal.vue"
import { reviewPayVoucherSubmit } from "@/api/review.js"
export default {
  components:{ uploadVoucherDialog, commonPasswordModal },
  data() {
    return {
      modalShow: false,
      tableData: [],
      title:"",
      status:1,
      columns: [
        {
          title: "祺信编号",
          dataIndex: "gldId",
          ellipsis: true
        },
        {
          title: "付款金额(元)",
          dataIndex: "payAmount",
          scopedSlots: { customRender: "payAmount" }
        },
        {
          title: "到期日期",
          width: "100px",
          dataIndex: "exDate",
          scopedSlots: { customRender: "exDate" }
        },
        {
          title: "操作",
          dataIndex: "operation",
          scopedSlots: { customRender: "operation" }
        }
      ]
    };
  },
  created() {},
  methods: {
    open({ tableData, title, status }) {
      this.modalShow = true;
      this.title = title;
      this.status = status;
      this.tableData = this.utils.deepClone(tableData || []);
    },
    close() {
      this.modalShow = false;
      this.tableData = [];
    },
    // 打开凭证的弹窗
    uploadVoucher(record,type){
      this.$refs.uploadVoucherDialog.open({
        record:record,
        type
      })
    },
    openPasswordDialog(btn) {
      this.btn = btn;
      this.$refs.commonPasswordModal.open();
    },
    passwordSuccess(txnPwd){
      reviewPayVoucherSubmit({
        gldId:this.tableData[0].gldId,
        txnPwd,
        status:this.status
      }).then(res => {
        this.btn && this.btn.closeLoad();
        this.$message.success("兑付凭证提交审核成功");
        this.close();
        this.$emit("success");
      }).catch(e => {
        this.btn && this.btn.closeLoad();
      })
    }
  },
  watch: {},
  activated() {}
};
</script>
<style scoped lang="less">
.img-tip {
  white-space: nowrap;
}
</style>



// WEBPACK FOOTER //
// src/pages/review/cashing/cashing-password-modal.vue